
import {Component, Vue} from 'vue-property-decorator';
import {IUserProfile} from '@/interfaces/user';
import {
  dispatchCreateUser, dispatchGetFormsAdmin, dispatchGetGroups, dispatchGetInstitutions, dispatchGetPermissions,
  dispatchGetRolesAdmin,
  dispatchGetUserAdmin,
  dispatchUpdateUser,
} from '@/store/admin/actions';
import {
  readAdminForms,
  readAdminGroups,
  readAdminOneUser,
  readAdminRoles,
  readAdminUsers,
  readInstitutions
} from '@/store/admin/getters';
import {rules, stringToNumber} from '@/utils';
import {readPermissions, readUserProfile} from '@/store/main/getters';
import {IPermission} from "@/interfaces/permission";
import {IGroup} from "@/interfaces/group";

@Component
export default class CRUDUser extends Vue {
  private title: string = `${this.$t('crud.create')} ${this.$t('user')}`;
  private password2: string = '';
  private userId: number = -1;
  private rules: any = rules;
  private resetPassword: boolean = false;

  private valid: boolean = true;
  private user: IUserProfile = {is_active: true} as IUserProfile;

  private userPermissionsToSave: number[] = []
  private groupsToSave: number[] = []
  private formsToSave: number[] = []

  private get currentUser(): IUserProfile {
    return readUserProfile(this.$store);
  }

  public async mounted() {
    this.userId = this.$router.currentRoute.params.id as unknown as number;
    if (this.roles.length === 0) {
      await dispatchGetRolesAdmin(this.$store);
    }

    await dispatchGetInstitutions(this.$store)
    await dispatchGetGroups(this.$store)
    await dispatchGetPermissions(this.$store)
    await dispatchGetFormsAdmin(this.$store)

    if (this.userId > 0) {
      await dispatchGetUserAdmin(this.$store, this.userId);
      this.title = `${this.$t('crud.update')} ${this.$t('user')}`;
      this.user = readAdminOneUser(this.$store)(+this.userId) as IUserProfile;

      //@ts-ignore
      this.userPermissionsToSave = this.user.permissions.map((item: IPermission) => item.id);
      //@ts-ignore
      this.groupsToSave = this.user.groups.map((item: IGroup) => item.id);
      //@ts-ignore
      this.formsToSave = this.user.forms.map((item: IForm) => item.id);

    } else {
      this.reset();
      this.userId = 0;
    }
  }

  public beforeRouteLeave(to, from, next) {
    this.user = {is_active: true} as IUserProfile;
    this.title = `${this.$t('crud.create')} ${this.$t('user')}`;
    this.userId = 0;
    next();
  }

  public reset() {
    this.user = {is_active: true} as IUserProfile;
  }

  public cancel() {
    this.$router.back();
  }

  public async submit() {
    const form: any = this.$refs.form_crud_user;
    if (await form.validate()) {
      const userToSave = {
        ...this.user,
        groups: this.groupsToSave,
        permissions: this.userPermissionsToSave,
        forms: this.formsToSave,
        cpf: stringToNumber(this.user.cpf),
      } as unknown as IUserProfile

      if (this.userId > 0) {
        if (await dispatchUpdateUser(this.$store, {id: this.userId, user: userToSave})) {
          await this.$router.push({name: 'main-admin-users-list'});
        }
      } else {
        if (await dispatchCreateUser(this.$store, {userProfile: userToSave, externalUserID: 0})) {
          // externalUserID is zero in this module, ever.
          await this.$router.push({name: 'main-admin-users-list'});
        }
      }
    }
  }

  private get roles() {
    return readAdminRoles(this.$store);
  }

  private get institutions() {
    return readInstitutions(this.$store);
  }

  private get userPermissions() {
    return readPermissions(this.$store);
  }

  private get groupPermissions() {
    return readAdminGroups(this.$store);
  }

  private get forms() {
    return readAdminForms(this.$store)
  }
}
